/* src/config/sidebarMenu.js - Modificado el 26-02-2026 */
/* ---------------------------------------------------- */

/* 
    Configuración central del Sidebar
    El frontend SOLO controla visibilidad (UX)
    El backend SIEMPRE valida permisos reales
 */


export const sidebarMenu = [

  /* ===========================
     🛠️ ADMINISTRACIÓN SISTEMA
     =========================== */
  {
    id: 'admin',
    title: '🛠️ Admin',
    group: 'GLOBAL',
    level: 1,
    roles: ['ADMINISTRADOR'],
    tipos: ['SISTEMA'],
    items: [
      { name: 'Clientes', link: '/clientes' },
      { name: 'Usuarios', link: '/usuarios' },
      { name: 'Entidades', link: '/entidades' },
      { name: 'Logs del Sistema', link: '/logsviewer' },
      { name: 'BullMQ Dashboard', link: '/bullmq' },
      { name: 'Métricas Overwatch', link: '/metrics' },
    ],
  },

  /* ===========================
     👤 CLIENTES
     =========================== */
  {
    id: 'clientes',
    title: '👤 Clientes',
    group: 'CLIENTES',
    level: 1,
    roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'],
    items: [
      { name: 'Mis Datos', link: '/misdatos' },
      { name: 'Carpetas Tributarias', link: '/carpetascli' },
      { name: 'Rentas F22', link: '/rentascli' },
      { name: 'Declaraciones Juradas', link: '/djcli' },
      { name: 'Libro de Ventas', link: '/libroventascli' },
      { name: 'Libro de Compras', link: '/librocomprascli' },
      { name: 'Resumen Ventas', link: '/resumenventascli' },
      { name: 'Resumen Compras', link: '/resumencomprascli' },
      { name: 'Estadística Ventas', link: '/estadisticaventascli' },
      { name: 'Estadística Compras', link: '/estadisticacomprascli' },
      { name: 'Informe Financiero', link: '/informefinancierocliu' },
      { name: 'Tracking', link: '/seguimiento' },
      { name: 'Dashboard', link: '/dashboard' },
    ],
  },

  {
    id: "clientes_extractores",
    title: "⚡ On Demand",
    group: "CLIENTES",
    level: 2,
    roles: ["USUARIO", "SUPERVISOR", "ADMINISTRADOR"],
    items: [
      { name: "Extraer F22 Renta", link: "/Extraerf22rentacli" },

      { name: "Extraer Libro Ventas (Mensual)", link: "/Extraerlibroventascli" },
      { name: "Extraer Libro Compras (Mensual)", link: "/Extraerlibrocomprascli" },

      /* ✅ Nuevas opciones anuales */
      { name: "Extraer Libro Ventas (Anual)", link: "/ExtraerlibroventasAnualcli" },
      { name: "Extraer Libro Compras (Anual)", link: "/ExtraerlibrocomprasAnualcli" },

      { name: "Extraer Declaraciones Juradas", link: "/Extraerdjcli" },
    ],
  },

  {
    id: 'clientes_subir',
    title: '📤 Subir Carpeta',
    group: 'CLIENTES',
    level: 2,
    roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'],
    items: [
      { name: 'Subir Carpeta Tributaria', link: '/Subircarpetacli' },
    ],
  },

  /* ===========================
     👥 ENROLADOS
     =========================== */
  {
    id: 'enrolados',
    title: '👥 Enrolados',
    group: 'ENROLADOS',
    level: 1,
    roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'],
    items: [
      { name: 'Enrolados', link: '/enrolados' },
      { name: 'Carpetas Tributarias', link: '/carpetasenr' },
      { name: 'Rentas F22', link: '/rentasenr' },
      { name: 'Declaraciones Juradas', link: '/djenr' },
      { name: 'Libro de Ventas', link: '/libroventasenr' },
      { name: 'Libro de Compras', link: '/librocomprasenr' },
      { name: 'Resumen Ventas', link: '/resumenventasenr' },
      { name: 'Resumen Compras', link: '/resumencomprasenr' },
      { name: 'Estadística Ventas', link: '/estadisticaventasenr' },
      { name: 'Estadística Compras', link: '/estadisticacomprasenr' },
      { name: 'Deudas CMF', link: '/deudascmfenr' },
      { name: 'Informe Financiero', link: '/informefinancieroenru' },
      { name: 'Dashboard Financiero', link: '/dashboard' },
    ],
  },

  {
    id: "enrolados_extractores",
    title: "⚡ On Demand",
    group: "ENROLADOS",
    level: 2,
    roles: ["USUARIO", "SUPERVISOR", "ADMINISTRADOR"],
    items: [
      { name: "Extraer F22 Renta", link: "/Extraerf22rentaenr" },

      { name: "Extraer Libro Ventas (Mensual)", link: "/Extraerlibroventasenr" },
      { name: "Extraer Libro Compras (Mensual)", link: "/Extraerlibrocomprasenr" },

      /* ✅ Nuevas opciones anuales */
      { name: "Extraer Libro Ventas (Anual)", link: "/ExtraerlibroventasAnualenr" },
      { name: "Extraer Libro Compras (Anual)", link: "/ExtraerlibrocomprasAnualenr" },

      { name: "Extraer Deuda CMF", link: "/Extraercmfenr" },
      { name: "Extraer Declaraciones Juradas", link: "/Extraerdjenr" },
    ],
  },

  {
    id: 'enrolados_subir',
    title: '📤 Subir Enrolados',
    group: 'ENROLADOS',
    level: 2,
    roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'],
    items: [
      { name: 'Subir Carpeta Tributaria', link: '/Subircarpetaenr' },
    ],
  },

  /* ===========================
     💸 CESIONES
     =========================== */
  {
    id: 'deudor',
    title: '💸 Deudor',
    group: 'CESIONES',
    level: 1,
    roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'],
    items: [
      { name: 'Consulta Cesiones', link: '/cesionesdeu' },
      { name: 'Crear Pagos', link: '/crearpagos' },
      { name: 'Consulta Pagos', link: '/compagos' },
      { name: 'Conciliación', link: '/conciliacion' },
      { name: 'Comprobante Conciliación', link: '/comconcil' },
      { name: 'Mis Entidades', link: '/misentidades' },
      { name: 'Estadística Cesiones', link: '/estadisticacesionesdeu' },
    ],
  },

  {
    id: 'cesionario',
    title: '💰 Cesionario',
    group: 'CESIONES',
    level: 1,
    roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'],
    items: [
      { name: 'Consulta Cesiones', link: '/cesionesces' },
      { name: 'Estadística Cesiones', link: '/estadisticacesionesces' },
    ],
  },

  {
    id: 'cedente',
    title: '🤝 Cedente',
    group: 'CESIONES',
    level: 1,
    roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'],
    items: [
      { name: 'Consulta Cesiones', link: '/cesionesced' },
      { name: 'Estadística Cesiones', link: '/estadisticacesionesced' },
    ],
  },

  {
    id: "cesiones_extractores",
    title: "⚡ On Demand",
    group: "CESIONES",
    level: 1,
    roles: ["USUARIO", "SUPERVISOR", "ADMINISTRADOR"],
    items: [
      { name: 'Extraer Cesiones', link: '/extraercesionesdeu' },
    ],
  },


  /* ===========================
     🛢️ RECURSOS
     =========================== */
  {
    id: 'recursos',
    title: '🛢️ Recursos',
    group: 'RECURSOS',
    level: 1,
    roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'],
    items: [
      { name: 'FA Publicadas', link: '/publicadas' },
      { name: 'Extraer FA Publicadas', link: '/extraerfapublicadas' },
      { name: 'Indicadores Económicos', link: '/indicadores' },
    ],
  },

  /* ===========================
     🛢️ PROVEEDORES
     =========================== */
  {
    id: 'proveedores',
    title: '🛢️ Proveedores',
    group: 'PROVEEDORES',
    level: 1,
    roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'],
    items: [
      { name: 'Proveedores', link: '/proveedores' },
    ],
  },

];
